// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"7f6a595f","151":"26590954","204":"5cd7e2bf","355":"ed38e2b2","409":"bf51c351","459":"8715b5ee","543":"530ccb3d","860":"ce81df90","936":"d19ce582"}[chunkId] + ".chunk.js";
};